<template>
  <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top"  v-b-scrollspy:nav-scroller>
    <div class="container">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <!-- <b-navbar-brand class="navbar-brand" :to="{name:'Home_one'}"><img :src='"../assets/images/logo.png"' alt="logo"></b-navbar-brand> -->
    <b-navbar-brand class="navbar-brand" href="/tutorial_main"><img :src='"/static/logo_tutorial_big.png"' alt="logo"></b-navbar-brand>    
    <b-collapse class="default-nav"  is-nav id="nav_collapse">
      <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
          <b-nav-item href="/tutorial_main">HOME</b-nav-item>
          <b-nav-item href="/function">{{this.EventBus.getSystemText("nav_basic")}}</b-nav-item>
          <!-- <b-nav-item href="/menu">엔닷캐드 메뉴</b-nav-item>                     -->

          <!-- <b-nav-item-dropdown right-alignment text="메뉴 바로가기" :href='"/menu"' class="nav-link"  >
		        <b-dropdown-item class="nav-link text-center"   :href='"/menu/edit"' >편집</b-dropdown-item>
            <b-dropdown-item class="nav-link text-center"   :href='"/menu/tool"'>도구</b-dropdown-item>
            <b-dropdown-item class="nav-link text-center"   :href='"/menu/look"'>보기</b-dropdown-item>
            <b-dropdown-item class="nav-link text-center"   :href='"/menu/advanced"'>고급</b-dropdown-item>
            <b-dropdown-item class="nav-link text-center"   :href='"/menu/setting"'>설정</b-dropdown-item>
          </b-nav-item-dropdown> -->

          <div class="btn-group ml-2">
            <button type="button" class="btn bg-transparent dropdown-toggle btn-sm nav-link nav-drop" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="menu()">
              <span class="">{{this.EventBus.getSystemText("nav_menu")}}</span>
            </button>
            <div class="dropdown-menu drop">
              <a class="dropdown-item nav-link" href="/menu/edit">{{this.EventBus.getSystemText("nav_edit")}}</a>
              <a class="dropdown-item nav-link" href="/menu/tool">{{this.EventBus.getSystemText("nav_tool")}}</a>
              <a class="dropdown-item nav-link" href="/menu/look">{{this.EventBus.getSystemText("nav_view")}}</a>
              <a class="dropdown-item nav-link" href="/menu/advanced">{{this.EventBus.getSystemText("nav_advanced")}}</a>
              <a class="dropdown-item nav-link" href="/menu/setting">{{this.EventBus.getSystemText("nav_setting")}}</a>
            </div> 
          </div>

          <!-- <b-nav-item-dropdown right-alignment text="blog" class="nav-link">
		       <b-dropdown-item class="nav-link"   :href='"/explain_test"'>편집</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'blog_list'}" >Blog list</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_details'}" >Blog details</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_leftside'}">Left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_rightside'}">Right sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogLeftSidebar'}">Details left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogrightSidebar'}" >Details right sidebar</b-dropdown-item>
          </b-nav-item-dropdown> -->

          <!-- <b-nav-item href="/modeling">{{this.EventBus.getSystemText("nav_practice")}}</b-nav-item> -->
          <!-- <b-nav-item href="/contact_form">광고 문의</b-nav-item> -->

          <!-- <select class="ml-2 language" id="language" v-model="language" @change="changeLanguage($event)" style="font-size:13px;">
            <option value="Korean">&nbsp;한국어</option>
            <option value="English">English</option>
          </select> -->

          <!-- <b-nav-item href="#price">price</b-nav-item> -->

          <!-- <b-nav-item href="#download">download</b-nav-item>           -->

          <!-- <b-nav-item href="/#team">Team</b-nav-item> -->

          <!-- <b-nav-item href="#partner">partner</b-nav-item>           -->

          <!-- <b-nav-item href="#contact">Demo</b-nav-item> -->

          <!-- <b-nav-item href="/#map">Contact</b-nav-item> -->
          
          <!-- <b-nav-item href="/sign-in">Sign In</b-nav-item> -->
          
          <!-- <b-nav-item-dropdown right-alignment href="#Menu" text="Other page" class="nav-link ">
            <b-dropdown-item class="nav-link"  :to="{name:'Signin'}" :href='"/tovo/sign-in"'>sign in</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Signup'}" :href='"/tovo/sign-up"' >sign up</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'ForgetPassword'}" :href='"/tovo/forget-Password"' >Forget Password</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Thankyou'}" :href='"/tovo/thank-you"' >Thank you</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Review'}" :href='"/tovo/review"' >Review</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'pagenotfound'}" :href='"/tovo/404"' >404</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Faq'}" :href='"/tovo/faq"' >FAQ</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'download'}" :href='"/tovo/download"' >Download</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'coming_soon'}" :href='"/tovo/coming-soon"' >coming soon</b-dropdown-item>
          </b-nav-item-dropdown> -->

      </b-navbar-nav>
    </b-collapse>
    </div>
  </b-navbar>
</template>
<script>
export default {
  name: "Navbar",
  updated: function() {
    this.$nextTick(function() {
      if (this.language == undefined) {
        this.language = this.EventBus.language;
        if (this.language != undefined) {
          this.changeLanguage(this.language);
        }
      }
    });
  },
  created() {
    $(document).ready(function() {
      $(".nav-drop").mouseover(function() {
        $(".drop").show();
      });

      $(".nav-drop").on("mouseleave", function() {
        setTimeout(function() {
          if ($(".drop").visible == false) {
            $(".drop").hide();
          }
        }, 100);
      });

      $(".drop")
        .on("mouseenter", function() {
          $(".drop").show();
        })
        .on("mouseleave", function() {
          $(".drop").hide();
        });
    });
  },
  data() {
    return {
      language: this.EventBus.language
    };
  },
  methods: {
    menu(e) {
      window.location.href = "/menu";
    },
    changeLanguage(event) {
      this.EventBus.changeLanguage(event.target.value);
      window.location = window.location.pathname;
    }
  }
};
</script>

<style scoped>
.navbar-brand img {
  width: 120px;
}

.btn :hover {
  color: #1ecad3;
}
.dropdown-item {
  text-align: center;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar_tutorial.vue